import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import logo from "../assets/logo.png";
import { loginUser } from "../services/authService";
import { errorAlert, successAlert } from "../components/common/Swal";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const newErrors = {};
    if (!username.trim()) newErrors.username = "Username is required";
    if (!password.trim()) newErrors.password = "Password is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    try {
      const data = await loginUser({
        username,
        password,
      });

      // Store token in auth and local storage:
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      login(data.token);

      //login after indicating a confirm message
      successAlert("Logged in successfully!").then(() => {
        navigate("/dashboard");
      });
    } catch (err) {
      console.error("Login failed:", err);
      const errorMessage =
        err?.response?.data?.message || "Invalid Credentials.";
      errorAlert(errorMessage);
    } finally {
      setLoading(false);
    }

    // Demo login

    // if (username === "admin" && password === "admin123") {
    //   sessionStorage.setItem("kw_logged_in", "true");
    //   navigate("/dashboard");
    // } else {
    //   if (window.Swal) {
    //     window.Swal.fire({
    //       icon: "error",
    //       title: "Login Failed",
    //       text: "Invalid username or password. Try admin/admin123",
    //     });
    //   } else {
    //     alert("Invalid username or password.");
    //   }
    // }
  };

  return (
    <div
      className="login-body"
      style={{ background: "#202020", minHeight: "100vh" }}
    >
      {/* Header */}
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 fixed-top d-flex justify-content-start login-header">
            <div className="col ms-3 mt-2 d-flex align-items-center">
              <img
                src={logo}
                className="img-fluid"
                style={{ height: "5rem", width: "5rem" }}
                alt="KW-LOGO"
              />
              <span
                className="headerText ms-2"
                style={{
                  color: "#fff",
                  fontFamily: "'Inria Serif', serif",
                  fontSize: "2rem",
                }}
              >
                KW
              </span>
              <span
                className="ms-1"
                style={{
                  color: "#fff",
                  fontFamily: "'Inria Serif', serif",
                  fontSize: "1.4rem",
                }}
              >
                GOLD &amp; SILVER
              </span>
            </div>
          </div>
        </div>
      </div>

      <div
        className="container"
        style={{ paddingTop: "6rem", paddingBottom: "1rem" }}
      >
        {/* KW Logo Header */}
        <div className="col-12 d-flex align-items-center justify-content-center mt-5">
          <div className="fs-1" style={{ color: "#fff" }}>
            K
          </div>
          <div className="ms-2 me-2">
            <img
              src={logo}
              className="img-fluid"
              style={{ height: "6rem", width: "6rem" }}
              alt=""
            />
          </div>
          <div className="fs-1" style={{ color: "#fff" }}>
            W
          </div>
        </div>

        <div className="text-center mt-1 tagline">
          Gold &amp; Silver Accounting System
        </div>

        <div className="col-12 loginFormHead text-start">Login</div>

        <div className="col-12 bgCustomForm my-5 ps-3 pe-3 py-5">
          <form onSubmit={handleSubmit}>
            {/* Username */}
            <div className="col-12 emailField form-group">
              <label
                htmlFor="username"
                style={{ fontSize: "1.3rem", color: "black" }}
              >
                <i className="bi bi-person me-2"></i>Username
              </label>
              <input
                type="text"
                id="username"
                placeholder="username"
                className={`form-control mt-2 border-dark userName${errors.username ? " error" : ""}`}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              <span className="toggle-email">
                <i className="bi bi-person"></i>
              </span>
              {errors.username && (
                <span className="error-msg">{errors.username}</span>
              )}
            </div>

            {/* Password */}
            <div className="col-12 passwordField">
              <label htmlFor="password" className="label2">
                <i className="bi bi-lock me-2"></i>Password
              </label>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder="password"
                className={`form-control mt-2 border-dark userName${errors.password ? " error" : ""}`}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                <i
                  className={`bi ${showPassword ? "bi-eye-fill" : "bi-eye-slash-fill"}`}
                ></i>
              </span>
              {errors.password && (
                <span className="error-msg">{errors.password}</span>
              )}
            </div>

            <div className="d-flex align-items-center justify-content-center">
              <button
                type="submit"
                className="d-flex align-items-center justify-content-center loginBtn"
                disabled={loading}
              >
                {loading ? "Logging in..." : "Login"}
              </button>
            </div>

            <div className="d-flex align-items-center justify-content-between mt-3">
              <div className="col-6">
                <input
                  type="checkbox"
                  className="form-check-input border-dark"
                />
                <label style={{ marginTop: "-4px", marginLeft: "4px" }}>
                  Remember Me
                </label>
              </div>
              <div className="col-6 text-end">
                <a href="#" className="forgotPassword">
                  Forgot Password?
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
